var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['form-message', { error: _vm.error }]},[(_vm.error)?_c('div',{staticClass:"icon-column"},[_c('span',{class:[
                'icon',
                {
                    'uk-icon-exclamation-circle': _vm.error,
                    'uk-icon-small': _vm.error,
                    error: _vm.error,
                },
            ]})]):_vm._e(),_c('div',{staticClass:"message-column"},[(_vm.title)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"message"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }